import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import ClearIcon from '@material-ui/icons/Clear';

import * as math from '_core/utils/math';

import { TextFilter, TextTags, getTextApiParam } from './Text';


export const LoginValue = React.memo((props) => {
  const {
    column,
    data
  } = props;
  
  
  const value = math.getField(data, column.nameSplit[0]);
  
  return (
    <div >
      {value === undefined ? '-' : value}
    </div>
  );
});

export const LoginFilter = TextFilter;

export const LoginTags = TextTags;

export const getLoginApiParam = getTextApiParam;

export const getLoginExportValue = async (props, column, data) => {
  const value = math.getField(data, column.nameSplit[0]);
  
  return value === undefined ? '-' : value;
};
